let menu;

export function saveMenu(refMenu) {
    menu = refMenu;
}
